import qs from "qs";
import instance, { defaultBaseUrl } from "./APIConfig/Interceptor";
import { cn } from "./lib/utils";
import { getModuleNamingBySlug } from "./lib/Misc";

export const API = {
  // login and authentication
  LOGIN: "/login",
  LOGOUT: "/logout",
  REFRESH: "/refresh",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  CHANGE_PASSWORD: "/change-password",
  UPDATE_PROFILE: "/profile",
  GOOGLE_2FA_REGISTER: "/google-2fa-register",
  GOOGLE_2FA_VERIFY: "/google-2fa-verify",
  VERIFY_EMAIL_AUTHENTICATION: "/verify-email-authentication",
  EMAIL_AUTHENTICATION: "/email-authentication",
  VERIFY_BACKUP_EMAIL: "/verify-backup-email",
  ADD_BACKUP_EMAIL: "/add-backup-email",
  DELETE_2FA: "/disable-2fa",

  //Register
  FIRM_SIGNUP: "/register",
  EMAIL_VERIFICATION: "/email-verification",

  //Subsciption
  STRIPE_PRODUCTS: "/stripe/products",
  ORG_SUBSCRIPTION: "/stripe/subscription",
  ADD_ON_SUBSCRIPTION: "/stripe/aml-ctf/addon",
  GET_SUBSCRIPTION_DETAILS: "/stripe/subscription-details",
  GET_PAYMENT_METHODS: "/stripe/payment-methods",
  GET_SUBSCRIPTION_LIST_DETAILS: "/stripe/subscription-details",
  CANCEL_SUBSCRIPTION: "/stripe/cancel-subscription",
  GET_UPCOMING_INVOICE: "/stripe/upcoming-invoice",
  UPDATE_SUBSCRIPTION: "/stripe/update-subscription",

  //User Settings
  GET_USER_PROFILE: "/profile",

  // Organization
  GET_ORGANIZATIONS: "/organizations",
  ORGANIZATION_DETAILS: "/organizations",
  ORGANIZATION_ADD: "/organizations",
  ORGANIZATION_DELETE: "/organizations",

  // Trust
  GET_TRUSTS: "/trusts",
  TRUST_DETAILS: "/trusts",
  TRUST_ADD: "/trusts",
  TRUST_DELETE: "/trusts",

  // Combine Template
  DOWNLOAD_COMBINE_ASSET_TEMPLATE: "/combine-download/assets",
  IMPORT_COMBINE_ASSET: "/combine-import/assets",

  // Vendors
  VERFICATION_TYPES: "/verification-document-types",
  GET_VENDORS: "/vendors",
  VENDOR_DETAILS: "/vendors",
  VENDOR_ADD: "/vendors",
  VENDOR_DELETE: "/vendors",
  IMPORT_VENDOR: "/vendors/import",
  DOWNLOAD_VENDOR_TEMPLATE: "/vendors/download-sample",
  EXPORT_VENDOR: "/vendors/export",

  // Assets
  GET_ASSET: "/assets",
  ASSET_DELETE: "/assets",
  ASSET_DETAILS: "/assets",
  ASSET_ADD: "/assets",
  XERO_ASSET: "/xero/assets",
  ASSET_SYNC: "/assets/sync-with-xero",
  IMPORT_ASSET: "/assets/import",
  DOWNLOAD_ASSET_TEMPLATE: "/assets/download-sample",
  EXPORT_ASSET: "/assets/export",

  // CDD
  GET_CDDS: "/aml-ctf/cdds",
  GET_CDD_VERFIY: "/aml-ctf/cdds/verify",
  GET_CDD_VISUAL: "/aml-ctf/cdds/visual-verify",
  GET_CDD_RISK: "/aml-ctf/cdds/risk-update",
  GET_CDD_ESCALATED: "/aml-ctf/cdds/escalated",

  // All Contact
  GET_ALL_CONTACTS: "/all-contacts",

  // Contact
  GET_CONTACTS: "/contacts",
  CONTACT_DELETE: "/contacts",
  CONTACT_DETAILS: "/contacts",
  CONTACT_ADD: "/contacts",
  IMPORT_CONTACT: "/contacts/import",
  DOWNLOAD_CONTACT_TEMPLATE: "/contacts/download-sample",
  EXPORT_CONTACT: "/contacts/export",
  CONTACT_SYNC: "/contacts/sync",

  // Document list
  GET_DOCUMENT_LIST: "/documents",
  UPLOAD_DOCUMENT: "/documents",
  DELETE_DOCUMENT: "/documents",

  // Contractor-Types
  GET_CONTACT_TYPE: "/contact-types",
  CONTACT_TYPE_DELETE: "/contact-types",
  CONTACT_TYPE_DETAILS: "/contact-types",
  CONTACT_TYPE_Add: "/contact-types",
  CONTACT_TYPE_SYNC: "/contact-types/sync",

  // Sub Assets
  GET_SUB_ASSETS: "/sub-assets",
  SUB_ASSETS_DELETE: "/sub-assets",
  SUB_ASSETS_DETAILS: "/sub-assets",
  SUB_ASSETS_ADD: "/sub-assets",
  IMPORT_SUB_ASSET: "/sub-assets/import",
  DOWNLOAD_SUB_ASSET_TEMPLATE: "/sub-assets/download-sample",
  EXPORT_SUB_ASSET: "/sub-assets/export",

  // ContRacts
  GET_CONTRACTS: "/contracts",
  CONTRACT_DELETE: "/contracts",
  CONTRACT_DETAILS: "/contracts",
  CONTRACT_ADD: "/contracts",
  RECORD_CONTRACT_UPDATE: "/contracts/add-update",

  //Accounting
  GET_ACCOUNT_TYPES: "/account-types",
  GET_ACCOUNT_DATA: "/chart-of-accounts",
  ACCOUNT_DELETE: "/chart-of-accounts",
  ACCOUNT_DETAILS: "/chart-of-accounts",
  ACCOUNT_ADD: "/chart-of-accounts",
  IMPORT_ACCOUNT: "/chart-of-accounts/import",
  DOWNLOAD_ACCOUNT_TEMPLATE: "/chart-of-accounts/get-template",
  ACCOUNT_RESTORE: "/chart-of-accounts/restore",
  ACCOUNT_DELETE_ALL: "/chart-of-accounts/delete-all",
  COA_SYNC: "/chart-of-accounts/sync-with-xero",

  // Common
  GET_COUNTRY_LIST: "/countries",
  GET_STATE_LIST: "/states",
  GET_SUBURB_LIST: "/suburbs",
  GET_ALL_SUBURB_LIST: "/suburbs",
  GET_OFFICE_LIST: "/offices",
  GET_STAFF_MANAGER_LIST: "/users",

  //Basiq integration
  BASIQ_GET_USER: "/basiq/get-user",
  BASIQ_CREATE_USER: "basiq/create-user",
  BASIQ_DISCONNECT: "basiq/disconnect",

  //Yodlee integration
  YODLEE_GET_TOKEN: "/yodlee/get-token",
  SAVE_ACCOUNTS: "/yodlee/accounts",
  SAVE_PROVIDERS_ACCOUNTS: "/yodlee/providers",
  REQUEST_CLIENT_TO_CONNECT: "/yodlee/request-client-to-connect",

  REQUEST_BUILDER_TO_CONNECT: "/yodlee/request-builder-to-connect",

  //Providers(Bank)
  GET_PROVIDERS_BANK: "/yodlee/providers",
  PROVIDER_BANK_DISCONNECT: "/yodlee/providers/disconnect",

  //Bank
  GET_BANK_LIST: "/banks",

  //User Type
  GET_USER_TYPE_LIST: "/user-types",

  //ORGANIZATION_TYPES
  GET_ORGANIZATION_TYPES: "/organization-types",

  //User Type
  GET_PAYMENT_METHOD_LIST: "/payment-methods",

  //Search terms
  GET_TERMS: "/terms",
  TERM_DELETE: "/terms",
  ADD_TERM: "/terms",
  EDIT_TERM: "/terms",

  //Banking
  BANK_TRANSACTION_LIST: "/bank-transactions",
  BANK_TRANSACTION_BATCHES: "/bank-transaction-batches",
  TRANSACTION_DELETE: "/bank-transactions",
  TRANSACTION_DELETE_BULK: "/bank-transactions/bulk-delete",
  BANK_TRANSACTION_BY_BATCHES: "/bank-transaction-batches",
  REFRESH_BANK_TRANSACTION: "/yodlee/transactions",
  BANK_RECONCILIATION_LIST: "/bank-reconciliations",
  UPDATE_BANK_RECONCILIATION: "/bank-reconciliations",
  BANK_RECONCILIATION_BULK: "/bank-reconciliations/bulk",
  EMAIL_FOR_CLARIFICATION: "/bank-reconciliations/email-for-clarification",
  GET_ACCOUNTS: "/get-accounts",
  ADD_BANK_TRANSACTION: "/bank-transactions",
  UPDATE_BANK_TRANSACTION: "/bank-transactions",
  GET_PROJECT_FOR_BANK_RECONCILIATION: "/bank-reconciliations/get-projects",
  GET_RTA_PROJECT_FOR_BANK_RECONCILIATION: "/bank-reconciliations/rta-projects",
  PERMANETALY_DELETE_BANK_STATEMENT: "/bank-transactions/delete-permanent",
  DOWNLOAD_BANK_STATEMENT_TEMPLATE: "/bank-transactions/download-sample",
  BANK_STATEMENT_IMPORT: "/bank-transactions/import",

  //payments
  GET_PAYMENTS: "/payments",
  CREATE_PAYMENTS: "/payments",
  PAYMENT_ABA_RECEIPT: "/payments",

  //Journal Entry
  JOURNAL_ENTRIES: "/journal-entries",
  JOURNAL_ENTRIES_UNDO: "/journal-entries/undo",

  //Receipt
  GET_RECEIPT_ITEMS: "/receipts/details",
  GET_RECEIPT: "/receipts",
  RECEIPT_DOWNLOAD: "/receipts/download",
  CREATE_RECEIPT: "/receipts",
  RECEIPT_REFUND: "/receipts/refund",
  IMPORT_RECEIPT: "/receipts/import",
  DOWNLOAD_RECEIPT_TEMPLATE: "/receipts/download-sample",
  EXPORT_RECEIPT: "/receipts/export",
  RECEIPT_ARCHIVED: "/receipts/archived",
  GET_RECEIPT_REFUND_HISTORY: "/receipts/refund-history",

  //Report
  GET_TRIAL_BALANCE_DATA: "/reports/trial-balance-report",
  GET_TRIAL_BALANCE_ENTRIES_DATA: "/reports/trial-balance-entries-report",
  BANK_RECONCILED_TRANSACTION_BULK_REALLOCATE:
    "/bank-reconciliations/bulk-reallocate",

  LEDGER_ENTRY_REPORT: "/reports/ledger-entries-report",
  CONTACT_STATEMENT_REPORT: "/reports/contact-statement-report",
  VENDOR_STATEMENT_REPORT: "/reports/vendor-statement-report",
  CONTACT_STATEMENT_REPORT_DETAIL: "/reports/contact-statement-report-detail",
  VENDOR_STATEMENT_REPORT_DETAIL: "/reports/vendor-statement-report-detail",
  SUB_ASSET_STATEMENT_REPORT: "/reports/sub-asset-statement-report",
  TRANSACTION_REPORT: "/reports/transaction-report",
  GENERAL_LEDGER_REPORT: "/reports/general-ledger-report",
  ORG_GENERAL_LEDGER_REPORT: "/reports/trust-balances",
  MONTHLY_BANK_RECONCILIATION_REPORT:
    "/reports/monthly-bank-reconciliation-report",
  MONTHLY_BANK_RECONCILIATION_REPORT_ENTRIES:
    "/reports/monthly-bank-reconciliation-entries-report",
  CHANGE_MONTHLY_BANK_RECONCILIATION_BALANCE: "/monthly-balances",
  CONTRACT_SUMMARY_REPORT: "/reports/progress-payment-report",

  //Users
  GET_USER: "/users",
  USER: "/users",
  USER_PERMISSION: "/users/permissions",
  USER_ACTIVITY_LOGS: "/user-activites",
  USER_APPROVE: "/users/accept-reject",
  USER_RESEND_INVITATION: "/users/invite-mail",

  //Office
  GET_OFFICE: "/offices",
  OFFICE: "/offices",

  //Role
  GET_ROLE_LIST: "/roles",
  ROLE_STATUS: "/roles-status",

  //Admin Role
  GET_ADMIN_ROLE_LIST: "/admin/roles",
  ADMIN_ROLE_STATUS: "/admin/roles/status",
  ADMIN_ROLE_PERMISSION: "/admin/roles/permissions",

  //Admin Module
  GET_ADMIN_MODULE_LIST: "/admin/module-namings",

  //Module
  GET_MODULE_LIST: "/modules",

  //Project DashBoard
  GET_TRUST_DASHBOARD: "/trust-dashboard",
  GET_TRUST_DASHBOARD_GRAPH: "/dashboard-graph-data",

  //Principal
  GET_PRINCIPAL_DETAILS: "/principals",
  PRINCIPAL: "/principals",

  //Withdrawal
  GET_WITHDRAWAL_DETAILS: "/contacts",
  WITHDRAWAL: "/contacts",

  //General Setting
  GENERAL_SETTING_INTEGRATION: "/general-setting-integration",

  //Mail Settings
  MAIL_SETTINGS: "/email-settings",

  //XERO
  XERO_DISCONNECT: "/xero/revoke-token",
  XERO_REFRESH: "/xero/refresh",
  XERO_OAUTHREDIRECT: "/xero/oauthredirect",
  XERO_TENANTS: "/xero/tenants",
  XERO_CONTACTS: "/xero/get-contacts",
  XERO_SUPPLIERS: "/xero/get-suppliers",
  XERO_BENEFICARYS: "/xero/get-beneficiary",
  XERO_TENANTS_CONNECTIONS: "/xero/connections",
  XERO_DISCONNECT_TENANT: "/xero/connections/delete",
  XERO_COA: "/xero/chart-of-accounts",

  //BAS
  SUMMARY_REPORT: "/reports/gst-summary-bas",
  GST_TRANSACTION: "/reports/gst-transactions-bas",
  GST_TRANSACTION_DETAILS: "/reports/gst-transactions-details-bas",

  //Admin
  GET_SUBSCRIPTION_FOR_ADMIN: "/admin/subscriptions",
  GET_REGISTERED_USER_FOR_ADMIN: "/admin/registered-users",
  REGISTERED_USER_FOR_ADMIN_RESEND_EMAIL:
    "/admin/registered-users/resend-email",
  INVOICE_LIST: "/admin/invoice-list",
  ADMIN_DASHBOARD: "/admin/dashboard",

  // Admin States
  GET_ADMIN_STATE_LIST: "/admin/states",

  // Admin Suburb
  GET_ADMIN_SUBURB_LIST: "/admin/suburbs",

  // Admin User
  GET_ADMIN_USER_LIST: "/admin/users",

  // Public Holiday
  GET_HOLIDAY: "/admin/public-holidays",
  HOLIDAY: "/admin/public-holidays",

  GET_PAYMENTMETHOD_LIST: "/stripe/payment-methods",

  // ABA
  GET_ABA_LIST_DOWNLOAD: "/aba",
  GET_ABA_EXPAND_LIST: "/aba-payments",
  GET_ABA_LIST: "/payments",
  GENERATE_ABA: "/aba",
  UNDO_ABA: "/aba/undo",
  ABA_FILE_LIST: "/aba-file-list",
  DOWNLOAD_ABA_FILE: "/download-aba-file",
  REGENERATE_ABA: "/aba",
  ABA_TRANSACTION_FILES: "/aba-file-customer",
  ABA_EMAIL: "/aba-receipts/send-mail",

  //COA Financial Report
  GET_COA_TRIAL_BALANCE_DATA: "/reports/ca-trial-balance-report",
  GET_COA_TRIAL_BALANCE_ENTRIES_DATA:
    "/reports/ca-trial-balance-entries-report",
  COA_BANK_RECONCILED_TRANSACTION_BULK_REALLOCATE:
    "/bank-reconciliations/bulk-reallocate",

  COA_GENERAL_LEDGER_REPORT: "/reports/ca-general-ledger-report",
  COA_LEDGER_ENTRY_REPORT: "/reports/ca-ledger-entries-report",
  PROFIT_AND_LOSS_REPORT: "/reports/profit-and-loss-report",
  GET_PROFIT_AND_LOSS_ENTRIES_DATA: "/reports/profit-and-loss-entries-report",
  GET_PROFIT_AND_LOSS_CHART_DATA: "/reports/profit-and-loss-data",
  BALANCE_SHEET_REPORT: "/reports/balance-sheet-report",
  GET_BALANCE_SHEET_ENTRIES_DATA: "/reports/balance-sheet-entries-report",

  //Opening Balance
  OPENING_BALANCE: "/opening-balance",

  //Import Logs
  IMPORT_LOGS: "/contact-import-logs",

  //Chart of Account Import Logs
  COA_IMPORT_LOGS: "/chart-of-account-import-logs",

  //Project Import Logs
  PROJECT_IMPORT_LOGS: "/project-import-logs",

  //Paymentt Claim Import Logs
  PAYMENT_CLAIM_IMPORT_LOGS: "/payment-claim-import-logs",

  //Send Email with Additional Documents
  SEND_EMAIL_DOCS: "/send-mail",

  //Support Ticket
  SUPPORT_TICKET: "/support-tickets",
  ADMIN_SUPPORT_TICKET: "/admin/support-tickets",

  // Discount
  GET_DISCOUNT_CODES: "/discount-codes",
  DISCOUNT_CODE_DELETE: "/discount-codes",
  DISCOUNT_CODE_DETAILS: "/discount-codes",
  DISCOUNT_CODE_ADD: "/discount-codes",
  IMPORT_DISCOUNT_CODE: "/discount-codes/import",
  DOWNLOAD_DISCOUNT_CODE_TEMPLATE: "/discount-codes/download-sample",
  EXPORT_DISCOUNT_CODE: "/discount-codes/export",

  // Processing Fees
  GET_PROCESSING_FEE_CODES: "/processing-fees",
  PROCESSING_FEE_CODE_DELETE: "/processing-fees",
  PROCESSING_FEE_CODE_DETAILS: "/processing-fees",
  PROCESSING_FEE_CODE_ADD: "/processing-fees",
  IMPORT_PROCESSING_FEE_CODE: "/processing-fees/import",
  DOWNLOAD_PROCESSING_FEE_CODE_TEMPLATE: "/processing-fees/download-sample",
  EXPORT_PROCESSING_FEE_CODE: "/processing-fees/export",

  // Job
  GET_JOBS: "/jobs",
  JOB_DELETE: "/jobs",
  JOB_DETAILS: "/jobs",
  JOB_ADD: "/jobs",
  IMPORT_JOB: "/jobs/import",
  DOWNLOAD_JOB_TEMPLATE: "/jobs/download-sample",
  EXPORT_JOB: "/jobs/export",

  // Task
  GET_TASKS: "/tasks",
  TASK_DELETE: "/tasks",
  TASK_DETAILS: "/tasks",
  TASK_ADD: "/tasks",
  IMPORT_TASK: "/tasks/import",
  DOWNLOAD_TASK_TEMPLATE: "/tasks/download-sample",
  EXPORT_TASK: "/tasks/export",

  // Supplier
  GET_SUPPLIERS: "/suppliers",
  SUPPLIER_DELETE: "/suppliers",
  SUPPLIER_DETAILS: "/suppliers",
  SUPPLIER_ADD: "/suppliers",
  IMPORT_SUPPLIER: "/suppliers/import",
  DOWNLOAD_SUPPLIER_TEMPLATE: "/suppliers/download-sample",
  EXPORT_SUPPLIER: "/suppliers/export",
  SUPPLIER_SYNC: "/suppliers/sync",

  // Beneficary
  GET_BENEFICARYS: "/beneficiaries",
  BENEFICARY_DELETE: "/beneficiaries",
  BENEFICARY_DETAILS: "/beneficiaries",
  BENEFICARY_ADD: "/beneficiaries",
  IMPORT_BENEFICARY: "/beneficiaries/import",
  DOWNLOAD_BENEFICARY_TEMPLATE: "/beneficiaries/download-sample",
  EXPORT_BENEFICARY: "/beneficiaries/export",
  BENEFICARY_SYNC: "/beneficiaries/sync",

  // Job
  GET_DOCUMENTS: "/document",
  DOCUMENT_DELETE: "/document",
  DOCUMENT_DETAILS: "/document",
  DOCUMENT_ADD: "/document",
  DOCUMENT_SIGN: "/document/sign",
  DOCUMENT_VERIFY: "/document/verify",
  DOCUMENT_OCR: "/document/ocr",

  // Integrations
  INTEGRATION_DETAILS: "/integrations/details",
  INTEGRATION_CONNECT: "/integrations/get-token",
  INTEGRATION_DISCONNECT: "/integrations/disconnect",

  // Template Settings
  TEMPLATE_DETAILS: "/template",
  TEMPLATE_UPADATE: "/template",

  // Admin Versions
  GET_ADMIN_VERSIONS: "/admin/versions",
  ADMIN_VERSION_DELETE: "/admin/versions",
  ADMIN_VERSION_DETAILS: "/admin/versions",
  ADMIN_VERSION_ADD: "/admin/versions",

  // Admin Sections
  GET_ADMIN_SECTIONS: "/admin/sections",
  ADMIN_SECTION_DELETE: "/admin/sections",
  ADMIN_SECTION_DETAILS: "/admin/sections",
  ADMIN_SECTION_ADD: "/admin/sections",
  GET_SECTIONS: "/aml-ctf/sections",
  GET_ANALYSIS: "/aml-ctf/analysis",

  // Admin Questions
  GET_ADMIN_QUESTIONS_STATUS: "/admin/questions/update-status",
  GET_ADMIN_QUESTIONS: "/admin/questions",
  ADMIN_QUESTION_DELETE: "/admin/questions",
  ADMIN_QUESTION_DETAILS: "/admin/questions",
  ADMIN_QUESTION_ADD: "/admin/questions",

  // Admin Conditions
  GET_CONDITIONS: "/aml-ctf/conditions",
  GET_ADMIN_CONDITIONS: "/admin/conditions",
  ADMIN_CONDITION_DELETE: "/admin/conditions",
  ADMIN_CONDITION_DETAILS: "/admin/conditions",
  ADMIN_CONDITION_ADD: "/admin/conditions",

  // Admin Trainings
  GET_ADMIN_TRAININGS: "/admin/trainings",
  ADMIN_TRAINING_DELETE: "/admin/trainings",
  ADMIN_TRAINING_DETAILS: "/admin/trainings",
  ADMIN_TRAINING_ADD: "/admin/trainings",
  CREATE_TRAINING_QUIZ: "/aml-ctf/quizzes",
  GET_TRAININGS: "/aml-ctf/trainings",

  // Incidents
  GET_INCIDENTS: "/aml-ctf/incidents",
  INCIDENT_DETAILS: "/aml-ctf/incidents",
  INCIDENT_DOWNLOAD: "/aml-ctf/incidents/download",
  INCIDENT_ADD: "/aml-ctf/incidents",
  INCIDENT_DELETE: "/aml-ctf/incidents",
  INCIDENT_SUBMITTED: "/aml-ctf/incidents/submit",

  // Policies
  GET_POLICIES: "/aml-ctf/policies",
  DOWNLOAD_POLICIES_TEMPLATE: "/aml-ctf/policies/download-sample",
  POLICIES_DETAILS: "/aml-ctf/policies",
  POLICIES_ADD: "/aml-ctf/policies",
  POLICIES_DELETE: "/aml-ctf/policies",
  GET_ADMIN_POLICIES: "/admin/policies",
  ADMIN_POLICY_ADD: "/admin/policies",
  ADMIN_POLICY_DELETE: "/admin/policies",
  ADMIN_POLICY_DETAILS: "/admin/policies",

  // Program Summary
  GET_PROGRAM_SUMMARY: "/aml-ctf/program-summaries",
  DOWNLOAD_PROGRAM_SUMMARY_TEMPLATE:
    "/aml-ctf/program-summaries/download-sample",
  PROGRAM_SUMMARY_DETAILS: "/aml-ctf/program-summaries",
  PROGRAM_SUMMARY_ADD: "/aml-ctf/program-summaries",
  PROGRAM_SUMMARY_DELETE: "/aml-ctf/program-summaries",

  // Invoicing
  GET_INVOICINGS: "/invoices",
  INVOICING_DELETE: "/invoices",
  INVOICING_DETAILS: "/invoices",
  INVOICING_ADD: "/invoices",
  INVOICING_STATUS: "/invoices/status",
  INVOICING_DOWNLOAD: "/invoices/download",
  IMPORT_INVOICING: "/invoices/import",
  DOWNLOAD_INVOICING_TEMPLATE: "/invoices/download-sample",
  EXPORT_INVOICING: "/invoices/export",

  // Premium Variations
  GET_PREMIUM_VARIATIONS: "/premium-variations",

  // Risk Assessment
  GET_RISK_ASSESSMENT: "/aml-ctf/risk-assessments",

  // Opening balance
  GET_OPENING_BALANCES: "/opening-balances",
  OPENING_BALANCE_DELETE: "/opening-balances",
  OPENING_BALANCE_DETAILS: "/opening-balances",
  OPENING_BALANCE_ADD: "/opening-balances",

  // Withdrawal Account
  WITHDRAWAL_ACCOUNT: "/trust-bank-accounts",
};

// export const TableWrapClasses = "rounded-md border relative w-full overflow-auto";
export const TableWrapClasses = "relative w-full";

export const TableClasses = cn("w-full caption-bottom text-sm");

export const THClasses = cn(
  "bg-webPrimary text-white h-[34px] whitespace-nowrap px-2 text-left align-middle font-medium  [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] border-r last:border-r-0 selection:bg-white selection:text-webPrimary",
);

export const TDClasses = cn(
  "p-1 px-2 align-top whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] border-r last:border-r-0",
);

export const TRClasses = cn(
  "cursor-default bg-background border-b transition-colors hover:bg-muted dark:hover:bg-muted/50 data-[state=selected]:bg-muted z-10",
);

export const ActionTHClasses = cn(`${THClasses} sticky right-0 z-3 border-l`);

export const ActionTDClasses = cn(
  `${TDClasses} sticky right-0 z-3 border-l bg-background transition-colors hover:bg-muted dark:hover:bg-muted/50`,
);

// Idle Time in Minutes
export const idelTime = 30;

// Default Limit
export const defaultLimitPagination = 25;

export function get(endPoint, params = {}) {
  return instance.get(endPoint, params);
}

export function deleteCall(endPoint) {
  return instance.delete(endPoint);
}

export function putCall(endPoint, params) {
  return instance.put(endPoint, params);
}

export function post(endPoint, params, isStringify = true) {
  return instance.post(
    endPoint,
    params && (isStringify ? JSON.stringify(params) : qs.stringify(params)),
  );
}

export function fileUpload(endPoint, params, config) {
  return instance.post(endPoint, params, config);
}

export function fileUploadPut(endPoint, params, config) {
  return instance.put(endPoint, params, config);
}

export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export const imageDefaultPrefixPath = defaultBaseUrl() + "/public/uploads/";

// export const imageDefaultPrefixPath =
// "https://api.trustsoft.com.au/public/uploads/";

// BuildTrust
// export const IV = "68r6Sp3r6h26gfdr";
// export const SECRETKEY = "VahH9D2f3ethWo5UKwux7Ww6eDQcJVaP";

// New TrustSoft
export const IV = process.env.REACT_APP_IV;
export const SECRETKEY = process.env.REACT_APP_SECRET_KEY;

export const roleTypeOption = [
  {
    label: "Admin",
    value: "Admin",
  },
  {
    label: "Organization",
    value: "Organization",
  },
];

export const entityTypes = [
  { label: "Company", value: "Company" },
  // { label: "Global", value: "Global" },
  { label: "Partnership", value: "Partnership" },
  { label: "Sole Trader", value: "Sole Trader" },
  { label: "Superfund", value: "Superfund" },
  { label: "Trust", value: "Trust" },
  { label: "Other", value: "Other" },
];

export const AssetStatus = [
  { label: "Not Started", value: 0 },
  { label: "In Progress", value: 2 },
  { label: "On Hold", value: 3 },
  { label: "Completed", value: 1 },
];

export const PayeePayeerOptions = (organizationData) => {
  return [
    {
      label: getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      ),
      value: "vendor",
    },
    {
      label: getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      ),
      value: "contact",
    },
  ];
};

export const paymentMethods = [
  { label: "EFT", value: 1 },
  { label: "BPay", value: 2 },
  { label: "Cash", value: 3 },
  { label: "PayId", value: 4 },
];

export const verificationMethods = [
  { label: "Visual + Visual", value: 1 },
  { label: "Visual + Source Other", value: 2 },
];

// export const riskProfile = [
//   { label: "ML/TF/PF Low Risk", value: 1 },
//   { label: "ML/TF/PF High Risk", value: 2 },
//   { label: "AML/CTF Low Risk", value: 3 },
//   { label: "AML/CTF High Risk", value: 4 },
// ];

export const riskProfile = [
  { label: "Low Risk", value: "0" },
  { label: "Medium Risk", value: "2" },
  { label: "High Risk", value: "1" },
];

export const cddOptions = [
  { label: "Simplified", value: "0" },
  { label: "Enhanced", value: "1" },
];

export const cddCustomerTypeOptions = [
  { label: "Initial", value: "0" },
  { label: "Ongoing", value: "1" },
];

// export const cddOptions = [
//   { label: "Initial", value: 1 },
//   { label: "Ongoing", value: 2 },
// ];

export const taxOptions = [
  { label: "Yes", value: "1" },
  { label: "No", value: "0" },
];

export const sectionTypeOptions = [
  {
    label: "AML",
    value: "AML",
  },
  {
    label: "CTF",
    value: "CTF",
  },
];

export const incidentTypeOptions = [
  { label: "All", value: "" },
  { label: "SMRs (Suspicious matter reports)", value: "0" },
  { label: "TTRs (Threshold transaction reports)", value: "1" },
  // { label: "IVTs (International value transfer service reports)", value: "2" },
  { label: "CBMR (Cross border movement reports)", value: "3" },
  { label: "ACR (Annual compliance reports)", value: "4" },
];

export const incidentMethodType = [
  { label: "Cash", value: "0" },
  { label: "EFT", value: "1" },
  { label: "Virtual Asset (Crypto)", value: "2" },
  { label: "Kind", value: "3" },
];

export const invoiceTypeOptions = [
  { label: "Letter", value: "1" },
  { label: "Boxed", value: "2" },
];

export const onBoardingList = [
  {
    name: "heading:Trust",
  },
  {
    name: "label:A. Setup of:",
  },
  {
    name: "Organizations",
  },
  {
    name: "Trusts",
  },
  {
    name: "Integration for direct Bank Feeds",
  },
  {
    name: "Trust Payments & Trust Receipts",
  },
  {
    name: "label:B. Training On:",
  },
  {
    name: "Import Contacts, Suppliers, Beneficiaries",
  },
  {
    name: "Dashboard",
  },
  {
    name: ".ABA File Management",
  },
  {
    name: "Bank Reconciliation",
  },
  {
    name: "How to produce reports for auditors",
  },
  {
    name: "heading:AML/CTF",
  },
  {
    name: "label:A. Setup of:",
  },
  {
    name: "Firm profile and user access",
  },
  {
    name: "Risk assessments (products, services, geographies, client types)",
  },
  {
    name: "AML/CTF Policy and Program review",
  },
  {
    name: "Customer due diligence and KYC based on risk profiles",
  },
  {
    name: "Sanctions, PEP and adverse media screening settings",
  },
  {
    name: "AUSTRAC reporting templates",
  },
  {
    name: "label:B. Training On:",
  },
  {
    name: "Importing and maintaining client and beneficial owner records",
  },
  {
    name: "Updating AML/CTF Policy and Programs",
  },
  {
    name: "Managing suspicious activities, thresholds and investigations",
  },
  {
    name: "Simplified and Enhanced due diligence process",
  },
  {
    name: "Managing sanctions/PEP screening alerts and periodic re screening",
  },
  {
    name: "Tips on how to pass certified training and download individual certificate of completion",
  },
];
